import { Link } from "react-router-dom";
import { LogoModel } from "./logoModel";
import logo from "./assets/logo.svg";

export const Logo = ({ height = 70, width = 151 }: LogoModel) => {
  return (
    <Link
      to={"/"}
      className="logo-link"
      style={{ height: height, width: width }}
    >
      <img className="logo" src={logo} alt="" />
    </Link>
  );
};
